import * as ACTION from 'actions'

const initialState = {
  contact: {email: '', explanation: '', color: ''},
  contactTypes: null,
};

export function contact(state = initialState, action) {
  if (action == null) return state;

  switch (action.type) {
    case ACTION.FETCH_CONTACT:
      return {
        ...state,
        contact: action.contact,
        contactTypes: action.contactTypes
      };
    default:
      return state
  }
}
